import { useEffect, useCallback, useState } from 'react'
import { usePopper } from 'react-popper'
import { styles as dropdownStyles } from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown.styles'
import cn from 'classnames'

import AppsMenu from './'

const AppsMenuContainer = ({ referenceElement, className, open, setOpen }) => {
  // The reason for not using Dropdown component:
  // We need to be able to open this inside the UserItem dropdown menu
  const [popperElement, setPopperElement] = useState(null)
  const { styles: popperStyles, attributes } = usePopper(
    referenceElement,
    popperElement,
    {
      placement: 'right-end',
      strategy: 'fixed',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [-4, 9],
          },
        },
      ],
    }
  )

  // If click outside this element, remove this element
  const handleClickOutside = useCallback(
    event => {
      const path = event.path || (event.composedPath && event.composedPath())
      if (!path.includes(popperElement)) {
        setOpen(false)
      }
    },
    [setOpen, popperElement]
  )

  useEffect(
    () => {
      document.addEventListener('click', handleClickOutside)
      return () => {
        document.removeEventListener('click', handleClickOutside)
      }
    },
    [handleClickOutside]
  )

  return (
    <div css={dropdownStyles.base} ref={setPopperElement}>
      {open && (
        <AppsMenu
          css={[
            dropdownStyles.dropdownContainer,
            dropdownStyles.visible,
            popperStyles.popper,
          ]}
          className={cn('grui box-shadow-md', className)}
          setOpen={setOpen}
          {...attributes.popper}
        />
      )}
    </div>
  )
}

export default AppsMenuContainer
